{
  "cookies.en": {
    "title": "Cookie Policy",
    "showDates": true,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "11/06/2026"
  },
  "cookies.vi": {
    "title": "Chính sách Cookie",
    "showDates": true,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "11/06/2026"
  },
  "delete-account.en": {
    "title": "Request Nexa account deletion",
    "showDates": false,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "11/06/2026"
  },
  "delete-account.vi": {
    "title": "Yêu cầu xóa tài khoản Nexa",
    "showDates": false,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "11/06/2026"
  },
  "privacy.en": {
    "title": "Privacy Policy",
    "showDates": true,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "09/09/2026",
    "activeVersion": "v2.2",
    "versions": "privacy"
  },
  "privacy.v1.en": {
    "title": "Privacy Policy",
    "showDates": true,
    "effectiveDate": "05/06/2026",
    "lastUpdated": "11/06/2026",
    "activeVersion": "v1",
    "versions": "privacy"
  },
  "privacy.v1.vi": {
    "title": "Chính sách quyền riêng tư",
    "showDates": true,
    "effectiveDate": "05/06/2026",
    "lastUpdated": "11/06/2026",
    "activeVersion": "v1",
    "versions": "privacy"
  },
  "privacy.vi": {
    "title": "Chính sách quyền riêng tư",
    "showDates": true,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "09/09/2026",
    "activeVersion": "v2.2",
    "versions": "privacy"
  },
  "support.en": {
    "title": "Support",
    "showDates": false,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "11/06/2026"
  },
  "support.vi": {
    "title": "Hỗ trợ",
    "showDates": false,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "11/06/2026"
  },
  "terms.en": {
    "title": "Terms of Use",
    "showDates": true,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "09/09/2026",
    "activeVersion": "v2.2",
    "versions": "terms"
  },
  "terms.v1.en": {
    "title": "Terms of Use",
    "showDates": true,
    "effectiveDate": "05/06/2026",
    "lastUpdated": "11/06/2026",
    "activeVersion": "v1",
    "versions": "terms"
  },
  "terms.v1.vi": {
    "title": "Điều khoản sử dụng",
    "showDates": true,
    "effectiveDate": "05/06/2026",
    "lastUpdated": "11/06/2026",
    "activeVersion": "v1",
    "versions": "terms"
  },
  "terms.vi": {
    "title": "Điều khoản sử dụng",
    "showDates": true,
    "effectiveDate": "01/07/2026",
    "lastUpdated": "09/09/2026",
    "activeVersion": "v2.2",
    "versions": "terms"
  }
}
